import type {
  BonusCreateFileResponse,
} from '@modules/players-bonuses/submodules/create/submodules/file-bonus-create/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { PLAYERS_BONUSES_LIST_QUERY_KEY } from '@modules/players-bonuses/constants';
import { PLAYER_BONUS_CREATE_PERMISSIONS } from '@modules/players-bonuses/submodules/create/constants';
import {
  BONUS_FILE_CREATE_API_URL,
  BONUS_FILE_CREATE_MUTATION_KEY,
} from '@modules/players-bonuses/submodules/create/submodules/file-bonus-create/constants';
import { useToastStore } from '@modules/toast/store';

export default function useFileCreateBonusMutation(): ReturnType<
    typeof useContextMutation<BonusCreateFileResponse, Error, FormData>
> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<BonusCreateFileResponse, Error, FormData>({
    mutationKey: [BONUS_FILE_CREATE_MUTATION_KEY],
    mutationFn: (file) => fetchPost<BonusCreateFileResponse>(
      BONUS_FILE_CREATE_API_URL,
      file,
      { permission: PLAYER_BONUS_CREATE_PERMISSIONS.PLAYER_BONUS_CREATE },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [PLAYERS_BONUSES_LIST_QUERY_KEY] });
      displayPresetToast('created');
    },
  });
}
